import {Component, computed, inject, input, OnInit} from '@angular/core';
import {GridModel} from '../../../shared/model/page-grid';
import {KtVpoAdjustmentsGridService} from '../../service/kt-vpo-adjustments-grid.service';
import {IKtVpoAdjustmentListItem} from '../../interfaces/kt-trip.interface';

@Component({
  selector: 'app-kt-vpo-adjustments-list',
  templateUrl: './kt-vpo-adjustments-list.component.html',
  standalone: false,
})
export class KtVpoAdjustmentsListComponent implements OnInit {
  private readonly gridService = inject(KtVpoAdjustmentsGridService);

  readonly salesOrderId = input<number | null>(null);

  protected readonly gridConfig = computed<GridModel<IKtVpoAdjustmentListItem>>(() => ({
    gridDataTestId: 'kt-vpo-adjustments-list',
    gridTitle: 'VPO Adjustments',
    defaultPageSize: 25,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'Adjustment ID',
        sort: true,
      },
      {
        columnProperty: 'sequenceNo',
        columnHeader: 'Seq #',
        sort: true,
      },
      {
        columnProperty: 'productTypeName',
        columnHeader: 'Product Type',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'vendorName',
        columnHeader: 'Vendor',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'vendorInterfaceId',
        columnHeader: 'Vendor Interface ID',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'subVendorName',
        columnHeader: 'Sub-Vendor',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'subVendorInterfaceId',
        columnHeader: 'Sub-Vendor Interface ID',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'subVendorLegalEntity',
        columnHeader: 'Sub-Vendor Legal Entity',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'commissionAgencyName',
        columnHeader: 'Tour Agency',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'commissionAgencyParentName',
        columnHeader: 'Tour Agency Parent',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'previousAmount',
        columnHeader: 'Previous Amount',
        sort: false,
      },
      {
        columnProperty: 'newAmount',
        columnHeader: 'New Amount',
        sort: false,
      },
      {
        columnProperty: 'deltaAmount',
        columnHeader: 'Delta Amount',
        sort: false,
      },
      {
        columnProperty: 'deltaAmountUSD',
        columnHeader: 'Delta Amount USD',
        sort: false,
      },
      {
        columnProperty: 'currencyCode',
        columnHeader: 'Currency',
        sort: false,
      },
    ],
    gridGetService: this.gridService,
  }));

  public ngOnInit(): void {
    this.gridService.salesOrderId = this.salesOrderId();
  }
}
